import {configureStore as configureStoreRedux} from '@reduxjs/toolkit';
import {createLogger} from 'redux-logger';
import {createStateSyncMiddleware, initMessageListener} from 'redux-state-sync';

import envVariables from '../consts/envVariables';
import storeSliceNames from '../consts/storeSliceNames';
import logLevels from '../services/logger/logLevels';
import aiAssistant from './slice/aiAssistant';
import auth from './slice/auth';
import global from './slice/global';
import iotDevices from './slice/iotDevices';
import loyalty from './slice/loyalty';
import message from './slice/message';
import modal from './slice/modal';
import monitoring from './slice/monitoring';
import networks from './slice/networks';
import retail from './slice/retail';
import session from './slice/session';
import sidewalk from './slice/sidewalk';

let dispatch;
let getState;

const reducer = {
    aiAssistant,
    auth,
    networks,
    global,
    iotDevices,
    loyalty,
    modal,
    monitoring,
    retail,
    session,
    message,
    sidewalk,
};

const loggerMiddleware = createLogger({
    actionTransformer: (action) => {
        const {$uuid, $wuid, ...cleanAction} = action;

        return cleanAction;
    },
});

const storeSyncSlicesWhitelist = [storeSliceNames.auth, storeSliceNames.iotDevices, storeSliceNames.loyalty];

const storeSyncMiddleware = createStateSyncMiddleware({
    predicate: (action) => {
        const {type} = action;
        const sliceName = type.split('/')[0];

        return storeSyncSlicesWhitelist.includes(sliceName);
    },
});

const configureStore = () => {
    const store = configureStoreRedux({
        reducer,
        middleware: (getDefaultMiddleware) => {
            const isLogStateEnabled = envVariables.CONSOLE_LOG_LEVEL !== logLevels.SILENT.name;
            const middlewares = getDefaultMiddleware();

            middlewares.push(storeSyncMiddleware);

            if (isLogStateEnabled) {
                middlewares.push(loggerMiddleware);
            }

            return middlewares;
        },
        devTools: import.meta.env.DEV,
    });

    dispatch = store.dispatch;
    getState = store.getState;

    initMessageListener(store);
    return store;
};

export {configureStore, dispatch, getState};
